import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { BalanceQueryKeys } from "./balanceQueryKeys";
import {
  BalanceTransactionsPaginatedParams,
  getBalanceTransactions,
  getBalanceTransactionsPaginated,
} from "@/api/users";

export const useBalanceTransactions = () => {
  return useQuery({
    queryKey: [BalanceQueryKeys.Transactions],
    placeholderData: keepPreviousData,
    queryFn: getBalanceTransactions,
  });
};

// Server-side paginated ledger for the admin transaction-history page.
export const useBalanceTransactionsPaginated = (
  params: BalanceTransactionsPaginatedParams
) => {
  return useQuery({
    queryKey: [BalanceQueryKeys.TransactionsPaginated, params],
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) =>
      getBalanceTransactionsPaginated({ signal, params }),
  });
};
